import React from "react";
import FormaPago from "../../components/Cotizacion/CotizacionFormaPago";
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";

class ContainerPagos extends React.Component {

render() {
    return (
      <main className="cr-app bg-light">
        <div className="cr-content container-fluid">
          <div className="container-body-spaces">
            <FormaPago/>
          </div>
        </div>
      </main>
    );
  }
}

const mapStateToProps = state => ({
  datosPago:state.datosPago,
});

const mapDispatchToProps = dispatch => {
  return {
  };
};

export default withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(ContainerPagos)
);
